import { Component, forwardRef, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR
} from '@angular/forms';
import {
  CvaFormGroupComponent,
  ResetOptions
} from '@liberty-financial/agp-shared';
import { GuidUtil } from '@liberty-financial/ng-core';

type YesOrNoQuestion = 'Yes' | 'No';
@Component({
  selector: 'spark-shared-yes-or-no-question',
  templateUrl: './yes-or-no.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => YesOrNoQuestionComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => YesOrNoQuestionComponent),
      multi: true
    }
  ]
})
export class YesOrNoQuestionComponent extends CvaFormGroupComponent<
  boolean,
  YesOrNoQuestion
> {
  @Input() identifier = GuidUtil.generate();
  @Input() label!: string;
  @Input() isRequired = false;
  options = [
    {
      label: 'Yes',
      value: 'Yes'
    },
    {
      label: 'No',
      value: 'No'
    }
  ];

  form = new FormControl<YesOrNoQuestion>('No', { nonNullable: true });
  formGroup = new FormGroup({
    question: this.form
  });

  protected reset(opts?: ResetOptions | undefined): void {
    this.form.reset(undefined, opts);
  }

  transformToModel = (value: YesOrNoQuestion): boolean => value === 'Yes';
  transformToForm = (value: boolean): YesOrNoQuestion => (value ? 'Yes' : 'No');
}
